

export async function uploadToMSBucket(apiKey: string, file: File, isPublic: boolean): Promise<string> {


  return ;
}
